// Matavimo vizito ("Meistras į namus") kainos skaičiavimas — viena bendra
// funkcija, kurią naudoja IR gyva kainos suvestinė formoje (src/pages/Carpenter.jsx),
// IR galutinė suma, siunčiama į Paysera — kad tarp jų niekada nebūtų skirtumo
// (ta pati klaidų klasė, kokia jau buvo rasta/taisyta Checkout.jsx/calculatePrice.js:
// suvestinėje rodoma viena suma, o apmokestinama kita). Žr. ClickUp "Meistras į
// namus. Papildomi klausimai matavimams vietoje." — mockup'e aprašyta kainodara
// perkelta čia tiksliai, pridedant tik nuolaidos kodo atėmimą (mockup'e kodas
// buvo tik UI pliušas, realiai neatimdavo iš sumos).

export const FURNITURE_TYPES = [
  'Spinta varstomomis durimis', 'Spinta stumdomomis durimis', 'TV baldas',
  'Svetainės baldas', 'Lentyna', 'Vonios praustuvo spintelė', 'Vonios spintelė',
  'Komoda', 'Drabužinė', 'Virtuvė', 'Kita',
];

export const VISIT_PRICES = {
  self: 34.99,
  masterBase: 69.99, // apima atvykimą + 1-o baldo matavimą
  extraItem: 29.99, // kiekvienas papildomas baldas (2-as ir toliau)
  kitchen: 100, // priedas, jei baldo tipas "Virtuvė" (taikomas BET KURIAM, ne tik pirmam, baldui)
  afterHours: 50, // piko metas (15:00-19:00 darbo dienomis) — nekompensuojama
  viz: 49.99, // 3D vizualizacija VIENAM baldui — nekompensuojama
};

export const isKitchenItem = (item) => item?.type === 'Virtuvė';

export const emptyFurnitureItem = () => ({ type: '', customType: '', viz: false });

// `furnitureIncomplete`/validacija naudoja TĄ PATĮ apibrėžimą visur (formoje IR
// serverio pusėje per carpenter.js), kad "Kita" tipas be įrašyto teksto niekada
// nepraslystų nė vienu keliu.
export const isFurnitureItemComplete = (item) => !!item?.type && (item.type !== 'Kita' || !!item.customType?.trim());

export function calculateVisitPrice({ visitType, furnitureItems = [], afterHours = false, discountAmount = 0 }) {
  const safeDiscount = Math.max(0, Number(discountAmount) || 0);

  if (visitType === 'self') {
    const base = VISIT_PRICES.self;
    const total = Math.max(0, base - safeDiscount);
    return {
      total, deductible: base, base, extra: 0, kitchenFeeTotal: 0, afterHoursFee: 0, vizFee: 0,
      discountAmount: safeDiscount, kitchenCount: 0, vizCount: 0,
    };
  }

  const items = furnitureItems.length > 0 ? furnitureItems : [emptyFurnitureItem()];
  const itemFee = (i) => (i === 0 ? 0 : VISIT_PRICES.extraItem) + (isKitchenItem(items[i]) ? VISIT_PRICES.kitchen : 0);
  const furnitureFees = items.reduce((sum, _item, i) => sum + itemFee(i), 0);
  const kitchenCount = items.filter(isKitchenItem).length;
  const kitchenFeeTotal = kitchenCount * VISIT_PRICES.kitchen;
  const extra = furnitureFees - kitchenFeeTotal;
  const afterHoursFee = afterHours ? VISIT_PRICES.afterHours : 0;
  const vizCount = items.filter((f) => f.viz).length;
  const vizFee = vizCount * VISIT_PRICES.viz;
  const base = VISIT_PRICES.masterBase;
  const deductible = base + furnitureFees;
  const rawTotal = base + furnitureFees + afterHoursFee + vizFee;
  const total = Math.max(0, rawTotal - safeDiscount);

  return { total, deductible, base, extra, kitchenFeeTotal, afterHoursFee, vizFee, discountAmount: safeDiscount, kitchenCount, vizCount };
}
